import $ from 'jquery'
import {Core} from '../../../assets/src/scripts/core.js'

/**
 * Section « Features folders », deux affichages.
 *
 * Tabs : slider.js initialise le slider de contenus et le slider d'images (synchronisés
 * par asNavFor). Les onglets pilotent le slider de contenus ; à chaque changement de
 * slide, l'onglet actif suit et revient dans la zone visible de la barre (scrollable).
 *
 * Folders : sur desktop, les dossiers s'empilent en sticky (CSS). Le point actif est le
 * dernier dossier qui couvre la ligne médiane de l'écran. Sous lg, slider.js transforme
 * la liste en slider et la pagination verticale est masquée.
 *
 * @author welp
 */
export class FeaturesFolders {

  constructor($container) {
    if (Core.isAdmin()) return

    this.$tabs = $container.find('.features-folders-tab')
    this.$content = $container.find('.features-folders-content')
    this.$list = $container.find('.features-folders-list')
    this.$folders = $container.find('.features-folders-folder')
    this.$dots = $container.find('.features-folders-pagination-dot')

    if (this.$tabs.length) {
      this.bar = this.$tabs[0].parentElement
      this.$tabs.on('click', this.handleClickTab.bind(this))
      this.$content.on('beforeChange', this.handleBeforeChange.bind(this))
      this.bar.addEventListener('scroll', this.updateNavFade.bind(this), {passive: true})
      window.addEventListener('resize', this.updateNavFade.bind(this))
      document.fonts.ready.then(this.updateNavFade.bind(this))
    }

    if (this.$dots.length) {
      this.foldersOnMiddleLine = new Set()
      const observer = new IntersectionObserver(this.handleIntersect.bind(this), {rootMargin: '-50% 0px -50% 0px'})
      this.$folders.each((index, folder) => observer.observe(folder))
      this.$dots.on('click', this.handleClickDot.bind(this))
    }
  }

  handleClickTab(e) {
    this.$content.slick('slickGoTo', this.$tabs.index(e.currentTarget))
  }

  handleBeforeChange(e, slick, currentSlide, nextSlide) {
    this.setActive(this.$tabs, nextSlide)

    const tab = this.$tabs[nextSlide]
    this.bar.scrollTo({left: tab.offsetLeft - (this.bar.clientWidth - tab.offsetWidth) / 2, behavior: 'smooth'})
  }

  /** Signale au CSS de quel côté des onglets dépassent (fondu desktop). */
  updateNavFade() {
    const {scrollLeft, clientWidth, scrollWidth} = this.bar
    this.bar.classList.toggle('has-overflow-start', scrollLeft > 1)
    this.bar.classList.toggle('has-overflow-end', scrollLeft + clientWidth < scrollWidth - 1)
  }

  handleIntersect(entries) {
    entries.forEach(entry => {
      const index = this.$folders.index(entry.target)
      entry.isIntersecting ? this.foldersOnMiddleLine.add(index) : this.foldersOnMiddleLine.delete(index)
    })

    if (this.foldersOnMiddleLine.size) {
      this.setActive(this.$dots, Math.max(...this.foldersOnMiddleLine))
    }
  }

  /**
   * Scrolle jusqu'à la position où le dossier se colle. Un élément sticky ne donne pas
   * sa position dans le flux : on la recalcule depuis le haut de la liste.
   */
  handleClickDot(e) {
    const index = this.$dots.index(e.currentTarget)
    const gap = parseFloat(getComputedStyle(this.$list[0]).rowGap) || 0
    let top = this.$list.offset().top

    for (let i = 0; i < index; i++) {
      top += this.$folders[i].offsetHeight + gap
    }

    window.scrollTo({top: top - parseFloat(getComputedStyle(this.$folders[index]).top), behavior: 'smooth'})
  }

  setActive($items, index) {
    $items.removeClass('active').removeAttr('aria-current')
    $items.eq(index).addClass('active').attr('aria-current', 'true')
  }
}
